// src/utils/environmentHelper.js

/**
 * Environment detection utility for domain management
 */

export const isLocalEnvironment = () => {
    if (typeof window === 'undefined') return false;
    
    const hostname = window.location.hostname;
    return hostname === 'localhost' || 
           hostname === '127.0.0.1' || 
           hostname.includes('localhost') ||
           hostname.startsWith('192.168.') ||
           hostname.startsWith('10.');
  };
  
  export const isProductionEnvironment = () => {
    return !isLocalEnvironment();
  };
  
  export const getEnvironmentConfig = () => {
    const isLocal = isLocalEnvironment();
    
    return {
      isLocal,
      isProduction: !isLocal,
      baseDomain: isLocal 
        ? `localhost${window.location.port ? ':' + window.location.port : ''}` 
        : 'yourapp.com',
      protocol: isLocal ? 'http' : 'https',
      sslEnabled: !isLocal,
      dnsVerificationRequired: !isLocal,
      apiUrl: isLocal 
        ? 'http://localhost:3001/api' 
        : 'https://api.yourapp.com',
    };
  };
  
  export const getFullDomainUrl = (subdomain, customDomain, domainType = 'subdomain') => {
    const config = getEnvironmentConfig();
    
    if (domainType === 'custom') {
      return `${config.protocol}://${customDomain}`;
    }
    
    if (config.isLocal) {
      return `${config.protocol}://${subdomain}.${config.baseDomain}`;
    }
    
    return `${config.protocol}://${subdomain}.${config.baseDomain}`;
  };
  
  export const shouldShowSSLOption = () => {
    return isProductionEnvironment();
  };
  
  export const shouldVerifyDNS = () => {
    return isProductionEnvironment();
  };
  
  export const getEnvironmentMessage = (feature) => {
    const isLocal = isLocalEnvironment();
    
    const messages = {
      ssl: isLocal 
        ? '🔒 SSL is disabled for localhost development'
        : 'SSL certificates will be automatically generated',
      dns: isLocal
        ? '✅ DNS verification skipped for localhost'
        : 'DNS records must be configured and verified',
      domain: isLocal
        ? 'Domains will use .localhost format for testing'
        : 'Production domains will use your configured domain',
      testing: isLocal
        ? '🧪 You are in development mode - some features are disabled'
        : '🚀 Production mode - all features enabled'
    };
    
    return messages[feature] || '';
  };
  
  export const getEnvironmentWarnings = () => {
    const isLocal = isLocalEnvironment();
    
    if (isLocal) {
      return [
        'You are running in localhost mode',
        'SSL certificate generation is disabled',
        'DNS verification is skipped',
        'Use .localhost subdomains for testing',
        'Edit your hosts file to test subdomains'
      ];
    }
    
    return [
      'Production environment detected',
      'SSL certificates will be generated',
      'DNS verification is required',
      'Ensure DNS records are properly configured'
    ];
  };
  
  export default {
    isLocalEnvironment,
    isProductionEnvironment,
    getEnvironmentConfig,
    getFullDomainUrl,
    shouldShowSSLOption,
    shouldVerifyDNS,
    getEnvironmentMessage,
    getEnvironmentWarnings
  };